export enum AddToBasketStatus {
  NoUserFound = 'NoUserFound',
  Failed = 'Failed',
  FailedButEstimate = 'FailedButEstimate',
  Succeeded = 'Succeeded',
}
